import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterSearchItemService {

  constructor( private datePipe: DatePipe) { }

  public itemSearchSend(itemSearch: any, cars: any) {
    
    let carsReturn: any[] = [];

    let currentYear = this.datePipe.transform(Date.now(), 'yyyy')

    switch (itemSearch.typeFilter) {

      case 'price':

          let currentCars: any;

          if(itemSearch.choice === 'plus') {

            currentCars = cars.filter(function(car: any) {
              return car['vehicle_price_location'] >= itemSearch.price;
            });

          } else {

            currentCars = cars.filter(function(car: any) {
              return car['vehicle_price_location'] <= itemSearch.price;
            });

          }

          carsReturn = currentCars

        break;
      
      case 'type':

          let tabCars: any[] = [];

          itemSearch['type'].forEach((element: string) => {
            
            let currentCars = cars.filter(function(car: any) {
              return car['vehicle_categorie'].trim().toLowerCase() === element.trim().toLowerCase();
            });

            tabCars = tabCars.concat(currentCars)

            // console.log(tabCars);

          });

          carsReturn = tabCars;

        break

      case 'moreFilter':

        let tabCarsPlace: any[] = [];
        let tabCarsCaracteristique: any[] = [];
        let tabCarsVitesse: any[] = [];
        let tabCarsMotor: any[] = [];
        let tabCarsYear: any[] = [];
        let tabCarsFinal: any[] = [];


        if(itemSearch.moreFilter['valuePlace'] > 0) {

          let currentCars: any;

          if(itemSearch.moreFilter['intervalPlace'] === 'plus') {

            currentCars = cars.filter(function(car: any) {
              return car['number_place_limit'] >= itemSearch.moreFilter['valuePlace'];
            });

          } else {

            currentCars = cars.filter(function(car: any) {
              return car['number_place_limit'] <= itemSearch.moreFilter['valuePlace'];
            });

          }

          tabCarsPlace = tabCarsPlace.concat(currentCars)

          tabCarsFinal = tabCarsPlace;

          // console.log(tabCarsPlace);

        }

        if(itemSearch.moreFilter['checkArrayEquipment'].length > 0) {

          let currentCarsSearch: any[] = [];

          if(tabCarsPlace.length <= 0) {

            currentCarsSearch = cars

          } else {

            currentCarsSearch = tabCarsPlace

          }

          // console.log(itemSearch.moreFilter, currentCarsSearch);

          let cli = itemSearch.moreFilter['checkArrayEquipment'].includes('1');
          let gps = itemSearch.moreFilter['checkArrayEquipment'].includes('2');
          let cot = itemSearch.moreFilter['checkArrayEquipment'].includes('3');
          let sie = itemSearch.moreFilter['checkArrayEquipment'].includes('4');
          // console.log(cli, gps, cot, sie)
          //Un un
            //Climatisation
            if(cli && !gps && !cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null;

              });

              tabCarsCaracteristique = currentCars;


            }
            //GPS 
            else if(!cli && gps && !cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['GPS'] != null;

              });

              tabCarsCaracteristique = currentCars;
              
            }
            //Coffre de toit 
            else if(!cli && !gps && cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['coffre_de_toi'] != null;

              });

              tabCarsCaracteristique = currentCars;
              
            }
            //Siege enfant 
            else if(!cli && !gps && !cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;
              
            }
          
          //Deux deux
            //Climatisation
            else if(cli && gps && !cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['GPS'] != null;

              });

              tabCarsCaracteristique = currentCars;

            } else if(cli && !gps && cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['coffre_de_toi'] != null;

              });

              tabCarsCaracteristique = currentCars;

            } else if(cli && !gps && !cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            } 
            //GPS
            else if(!cli && gps && cot && !sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['GPS'] != null || car['coffre_de_toi'] != null;

              });

              tabCarsCaracteristique = currentCars;

            } else if(!cli && gps && !cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['GPS'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            }
            //Coffre de toit
            else if(!cli && !gps && cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['coffre_de_toi'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            }

          //Trois trois
            //Climatisation  
            else if(cli && gps && cot && !sie) {
              
              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['GPS'] != null || car['coffre_de_toi'] != null;

              });

              tabCarsCaracteristique = currentCars;

            } else if(cli && gps && !cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['GPS'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            }
            //GPS
            else if(!cli && gps && cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['GPS'] != null || car['coffre_de_toi'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            }

          //Quatre quatre 
            //Totalité
            else if(cli && gps && cot && sie) {

              let currentCars = currentCarsSearch.filter(function(car: any) {
                
                return car['AirBag'] != null || car['GPS'] != null || car['coffre_de_toi'] != null || car['sieg_enfant'] != null;

              });

              tabCarsCaracteristique = currentCars;

            }


          // console.log(tabCarsCaracteristique);


          tabCarsFinal = tabCarsCaracteristique;

        }

        if(itemSearch.moreFilter['vitesse']) {

          let currentCarsSearch: any[] = [];

          if(tabCarsCaracteristique.length <= 0) {

            currentCarsSearch = cars

          } else {

            currentCarsSearch = tabCarsCaracteristique

          }

          tabCarsVitesse = currentCarsSearch.filter(function(car: any) {
            return car['gearboxe_lib'].trim().toLowerCase() == 'Automatique'.toLowerCase() || car['gearboxe_lib'].trim().toLowerCase() == 'Manuel'.toLowerCase()
                    || car['gearboxe_lib'].trim().toLowerCase() == 'Manuelle'.toLowerCase();
          });

          tabCarsFinal = tabCarsVitesse;

        }

        if(itemSearch.moreFilter['checkArrayMotor'].length > 0) {

          let currentCarsSearch: any[] = [];

          if(tabCarsVitesse.length <= 0) {

            currentCarsSearch = cars

          } else {

            currentCarsSearch = tabCarsVitesse

          }

          itemSearch.moreFilter['checkArrayMotor'].forEach((element: string) => {
           
            let currentCars = currentCarsSearch.filter(function(car: any) {
              
              return car['energy_lib'].trim().toLowerCase() == element.trim().toLowerCase();
            });
            
            tabCarsMotor = tabCarsMotor.concat(currentCars)

          });

          tabCarsFinal = tabCarsMotor;

        }

        if(itemSearch.moreFilter['year'] != null) {

          let currentCarsSearch: any[] = [];

          if(tabCarsMotor.length <= 0) {

            currentCarsSearch = cars;

          } else {

            currentCarsSearch = tabCarsMotor;

          }

          if(itemSearch.moreFilter['year'] != 'all') {

            tabCarsYear = currentCarsSearch.filter((car: any) => {

                let tabDate = car['vehicle_date_release'].split('-');
                let diff = Number(currentYear) - Number(tabDate[0])

                if(diff <=  Number(itemSearch.moreFilter['year'])) {

                  return car;

                }
                // console.log(tabDate, new Date('yyyy'), diff); 
            });

            tabCarsFinal = tabCarsYear;

          } else {

            tabCarsFinal = currentCarsSearch;

          }

        }

        carsReturn = tabCarsFinal;

        break;
    
      default:
        break;
    }

    // console.log(carsReturn);

    return carsReturn


  }
}
